import type {TvmList} from '../../types'

export const TESTING = {
  exp3: {host: 'exp3-matcher-srb-virt.taxi.tst.yandex.net', name: 'exp3-matcher-srb-virt', id: 2065044},
  account: {name: 'delivery-frontend-account-virt', id: 2070210},
  auth: {name: 'delivery-frontend-auth-virt', id: 2069645},
  route: {name: 'delivery-frontend-route-virt', id: 2070133},
  tariffs: {name: 'delivery-frontend-tariffs-virt', id: 2070137},
} as const satisfies TvmList
